module.exports = __webpack_public_path__ + "static/media/Group121.f0f92eef.png";